import { createBrowserRouter } from 'react-router'
import { AppShell } from '@/app/AppShell'
import { FlowScreen } from '@/app/screens/FlowScreen'
import { SettingsScreen } from '@/app/screens/SettingsScreen'
import { LayoutDesignerScreen } from '@/app/screens/LayoutDesignerScreen'
import { GuestScreen } from '@/app/screens/GuestScreen'
import { GuestError, NotFound, RouteError, ShellError } from '@/app/screens/ErrorScreens'

/**
 * The console is one guided flow plus the things that sit outside it.
 *
 * `/guest` deliberately lives outside the operator shell: it renders on a
 * second monitor with no chrome, no navigation and no agent banners.
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    // Only for AppShell ITSELF failing. It takes the banners and the upload
    // queue down with it, so this one owns the whole viewport.
    errorElement: <ShellError />,
    children: [
      {
        // A screen failed. Caught HERE — a pathless route inside the shell —
        // and not on the root route above, on purpose: AppShell owns the upload
        // queue (`startQueue` returns the function that stops it), so a
        // boundary above the shell would unmount it and halt every upload the
        // moment any one screen threw. Caught here, the error page fills the
        // space under the banners and sessions keep going up.
        errorElement: <RouteError />,
        children: [
          { index: true, element: <FlowScreen /> },
          { path: 'settings', element: <SettingsScreen /> },
          { path: 'layouts/new', element: <LayoutDesignerScreen /> },
          { path: 'layouts/:layoutId', element: <LayoutDesignerScreen /> },
          // Inside the shell too, for the same reason: a mistyped address is
          // no excuse to stop the queue.
          { path: '*', element: <NotFound /> },
        ],
      },
    ],
  },
  { path: '/guest', element: <GuestScreen />, errorElement: <GuestError /> },
])
